// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
   apiUrl: 'https://furniture-angular-project.onrender.com/api/',

  SERVER_URL: 'https://furniture-angular-project.onrender.com/api/',
  url: 'https://furniture-angular-project.onrender.com/api/',

  imageBaseUrl: 'https://furniture-angular-project-1.onrender.com/product_images/',
  otherimageBaseUrl: 'https://furniture-angular-project-1.onrender.com/other_images/',
  BannerUrl: 'https://furniture-angular-project-1.onrender.com/uploads/'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
